import Result from "./Result.jsx";
import { connect } from "react-redux";
import { markClassificationSportsmen } from "./MarkedSportsen/markSportsmenActions";

const mapStateToProps = (state) => {
  // let markedTeams = [];
  // if (state.ranking.entriesOwn) {
  //     markedTeams = state.ranking.entriesOwn.map(e=> e.zweelerTeamId);
  // }
  // return {
  //     entries: state.ranking.entries,
  //     columns: state.ranking.columns,
  //     game: state.games.current,
  //     userEntries: state.ranking.entriesOwn,
  //     markedTeams: markedTeams
  // };
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    onDetailsClick: (sportsmenId) => {
      dispatch(markClassificationSportsmen(sportsmenId));
    },
  };
};

const ResultContainer = connect(mapStateToProps, mapDispatchToProps)(Result);

export default ResultContainer;
